import React, { useState } from 'react';
import CardManagement from './CardManagement';
import AnalyticsDashboard from './AnalyticsDashboard';
import JsonImporter from './JsonImporter';

type AdminTab = 'import' | 'cards' | 'analytics';

const AdminPanel: React.FC = () => {
  const [activeTab, setActiveTab] = useState<AdminTab>('analytics');

  const renderContent = () => {
    switch (activeTab) {
      case 'import':
        return <JsonImporter />;
      case 'cards':
        return <CardManagement />;
      case 'analytics':
        return <AnalyticsDashboard />;
      default:
        return null;
    }
  };

  return (
    <div className="container mx-auto p-4 md:p-8 text-white">
      <h1 className="text-4xl font-bold mb-8">Admin Dashboard</h1>

      <div className="flex border-b border-gray-700 mb-6">
        <TabButton name="Analytics" tab="analytics" activeTab={activeTab} setActiveTab={setActiveTab} />
        <TabButton name="Kartenverwaltung" tab="cards" activeTab={activeTab} setActiveTab={setActiveTab} />
        <TabButton name="JSON Import" tab="import" activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>

      <div>
        {renderContent()}
      </div>
    </div>
  );
};

interface TabButtonProps {
  name: string;
  tab: AdminTab;
  activeTab: AdminTab;
  setActiveTab: (tab: AdminTab) => void;
}

const TabButton: React.FC<TabButtonProps> = ({ name, tab, activeTab, setActiveTab }) => {
  const isActive = activeTab === tab;
  return (
    <button
      onClick={() => setActiveTab(tab)}
      className={`px-6 py-3 font-semibold border-b-2 transition-colors ${
        isActive
          ? 'border-primary-400 text-primary-300'
          : 'border-transparent text-gray-400 hover:text-white'
      }`}
    >
      {name}
    </button>
  );
};

export default AdminPanel; 